import Game from "../../static/assets/gamepad.svg";
import Class from "../../static/assets/class.svg";
import Social from "../../static/assets/laugh.svg";
import Other from "../../static/assets/dance.svg";

const events = [
  {
    title: "McGameJam",
    image: Game,
    description:
      "The 2nd largest video game hackathon in Quebec, where attendees have 48 hours to create a game based on a chosen theme."
  },
  {
    title: "Tutorials",
    image: Class,
    description:
      "Game development workshops of all levels, from introduction to game development to game engine architecture and computer graphics."
  },
  {
    title: "GDM Social",
    image: Social,
    description:
      "Monthly meetups where our members share the projects they've been working on and socialize with each other."
  },
  {
    title: "Other Stuff",
    image: Other,
    description:
      "We have miscellaneous events throughout the year where we watch game dev talks, go out together, and present our games to the public!"
  }
];

export default events;
